/**
 * <event-console-analytics> — the console's Analytics destination. It mounts
 * `<analytics-report>` and hands it nothing: the panel resolves its own
 * subject from `consoleEventId`, so the destination is the mount and nothing
 * else.
 *
 * It exists to give the console's own rail a routed tag in the
 * `event-console-*` family its four siblings already share — the value in
 * RAIL_ITEMS doubles as the route's `when` and as the URL segment.
 *
 * The panel flows; this destination scrolls. The area mounts a destination
 * stretched to exactly the area's own box with its minimum height pinned to
 * zero, so a report taller than that box would paint its excess past its own
 * border box as ink no gesture reaches — the scroll region and the padding
 * every sibling destination carries therefore sit on the panel itself rather
 * than on a wrapper around it.
 */
import { overflowWithin } from "@mhmo91/schmancy/directives";
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { html } from "lit";
import "../../analytics/report.view.ts";

@schmancyElement("event-console-analytics")
export default class EventConsoleAnalyticsView extends SchmancyElement {
	override render() {
		return html`<analytics-report
			${overflowWithin()}
			class="h-full p-4 md:p-6"
		></analytics-report>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"event-console-analytics": EventConsoleAnalyticsView;
	}
}
